module.exports = {"pt":{"projects":"projetos","partners":"parceiros","papers":"publicações","source code":"código fonte","locale":"idioma","made with":"feito com","English":"inglês","Brazilian Portuguese":"português brasileiro","experiments":"experimentos","events":"eventos","members":"integrantes","soon":"em breve","check projects":"Veja os projetos de nossos membros","gpg public key":"chave pública gpg"},"en":{"check projects":"Check our members' projects"}}


//////////////////
// WEBPACK FOOTER
// ./data/translations.yaml
// module id = gutz
// module chunks = 0